import axios from 'axios'

export default {
  getUsers(filters, sorting, currentPage, pageSize) {
    const query = {
      params: {
        pageNumber: currentPage,
        perPage: pageSize
      }
    }
    query.params.filters = filters

    query.params.sorting = sorting

    if (sorting) {
      query.params.sorting.push(['id', 'ASC'])
    } else {
      query.params.sorting = [['id', 'ASC']]
    }

    return axios.get('/api/users', query)
  },

  getStudents(payload) {
    const query = {
      params: {
        filters: payload.filters,
        sorting: payload.sorting
      }
    }

    if (payload.sorting) {
      query.params.sorting.push(['id', 'ASC'])
    } else {
      query.params.sorting = [['id', 'ASC']]
    }

    return axios.get('/api/users/students', query)
  },

  getContacts(filters, sorting, currentPage, pageSize) {
    const query = {
      params: {
        perPage: pageSize,
        pageNumber: currentPage,
        chats: true
      }
    }
    query.params.filters = filters

    query.params.sorting = sorting

    if (sorting) {
      query.params.sorting.push(['id', 'ASC'])
    } else {
      query.params.sorting = [['id', 'ASC']]
    }
    return axios.get('/api/users', query)
  },

  updateUser(user) {
    return axios.put('/api/users', user)
  },

  resetPassword(data) {
    return axios.put('/api/users/password', data)
  },

  deleteUser(userId) {
    return axios.delete('/api/users', {
      data: {
        id: userId
      }
    })
  },
  translateStudents(studentsId) {
    return axios.put('/api/users/students/translate', studentsId)
  },
  undoTranslateStudents(studentsId) {
    return axios.put('/api/users/students/translate/undo', studentsId)
  },
  removeStudents(studentsId) {
    return axios.delete('/api/users/students/remove', {
      data: {
        studentsId
      }
    })
  },
  getUsersInterestedInProfessions() {
    return axios.get('/api/users/students/interested-in-professions')
  },
  getUserInterestedInProfessionUsersMarks() {
    return axios.get('/api/users/students/interested-users-marks')
  },
  markInterestedInProfessionStudent(id) {
    return axios.post(`/api/users/students/mark/${id}`)
  },
  unmarkInterestedInProfessionStudent(id) {
    return axios.post(`/api/users/students/unmark/${id}`)
  },
  getUserTestsMarks(id) {
    return axios.get(`/api/users/students/tests-marks/${id}`)
  },
  getAllUsersTestsMarks() {
    return axios.get(`/api/users/students/tests-marks`)
  },
  getAllUsersOlympiadsResults() {
    return axios.get(`/api/users/students/olympiad-participations`)
  }
}
